import { PlatformStatusBadge } from "@replicate/ui";
import { useQuery } from "@tanstack/react-query";

interface IncidentDatum {
  id: string;
  name: string;
  status: string;
  last_update_at: string;
  last_update_message: string;
}

function useIncidentIOStatus() {
  return useQuery({
    queryKey: ["incidentIOStatus"],
    queryFn: async () => {
      const res = await fetch("https://www.replicatestatus.com/api/v1/summary");
      if (!res.ok) {
        throw new Error("Failed to fetch incident status");
      }

      const json = (await res.json()) as {
        ongoing_incidents: IncidentDatum[];
      };

      return json.ongoing_incidents.length > 0 ? "degraded" : "healthy";
    },
  });
}

export default function PlatformStatus() {
  const { status, data } = useIncidentIOStatus();

  if (status === "pending" || status === "error") {
    return null;
  }

  return (
    <div className="platform-status">
      <PlatformStatusBadge
        url="https://www.replicatestatus.com"
        status={data}
      />
    </div>
  );
}
